if (typeof FomoInlineSetup_73002 != "object") {
  // snippet should not be run twice if it is requested twice

  FomoInlineSetup_73002 = {
    setupFomoInlineMessage: function (message, variables) {
      var nodes = document.getElementsByClassName("fomo-inline");
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];

        if (node.getAttribute("data-aid") == 73002) {
          node.setAttribute("data-server-response", JSON.stringify(variables));

          var shouldMessageBeDisplayed = true;

          var minCountToShow = node.getAttribute("data-min-count-to-show");

          var afterDataLoadedCallback = node.getAttribute(
            "data-after-data-loaded-callback"
          );
          if (afterDataLoadedCallback && window[afterDataLoadedCallback]) {
            window[afterDataLoadedCallback]({
              data: variables,
              node: node,
              aid: 73002,
              integration_key_name: "page_stream",
            });
          }

          if (!minCountToShow) {
            minCountToShow = 2;
          }

          if (node.innerHTML && node.innerHTML.indexOf("{{") > -1) {
            message = node.innerHTML;
          }

          if (minCountToShow && variables.count < minCountToShow) {
            node.setAttribute(
              "data-debug-message",
              "minCountToShow is not reached (" +
                minCountToShow +
                " > " +
                variables.count +
                "). Check if this product has recent sales!"
            );
            shouldMessageBeDisplayed = false;
          }

          for (key in variables) {
            var val = variables[key];

            message = message.replace("{{ " + key + " }}", val);
          }

          if (message.indexOf("{{") > -1) {
            // not all variables were replaced
            node.setAttribute(
              "data-debug-message",
              "Not all {{ variables }}  were replaced. Are curly brackets escaped? On Shopify you can escape curly brackets with: {% raw %}...{% endraw %}"
            );
            shouldMessageBeDisplayed = false;
          }

          if (shouldMessageBeDisplayed) {
            node.innerHTML = message;

            var customDisplayHandler = node.getAttribute(
              "data-custom-display-handler"
            );

            if (customDisplayHandler) {
              window[customDisplayHandler](node);
            } else {
              var renderedStyleDisplay = node.getAttribute(
                "data-rendered-style-display"
              );
              var display = "block";
              if (renderedStyleDisplay) {
                display = renderedStyleDisplay;
              }

              node.style.display = display;
            }

            var url = "https://stats.fomo.com/stats/save";

            try {
              var xhttp = new XMLHttpRequest();

              data = {
                aid_crypted: "vhIYSecmPj0=",
                type: "impr",
              };

              var q = [];

              for (var key in data) {
                q.push("s[" + key + "]=" + encodeURIComponent(data[key]));
              }

              var sendParams = q.join("&");

              xhttp.open("POST", url, 1);
              xhttp.setRequestHeader(
                "Content-type",
                "application/x-www-form-urlencoded"
              );
              xhttp.send(sendParams);
            } catch (ign) {}
          }

          var afterRenderCallback = node.getAttribute(
            "data-after-render-callback"
          );
          if (afterRenderCallback && window[afterRenderCallback]) {
            window[afterRenderCallback]({});
          }
        }
      }
    },

    fomoInlinePagestreamDataReady: function (data) {
      var message = "{{ count }} people bought in the last hour";
      FomoInlineSetup_73002.setupFomoInlineMessage(message, {
        count: data.count,
      });
    },
    service_url: function (encodedPath) {
      return (
        "https://e.fomo.com/dyn/page_stream/9tdanzaoMHu8sKqNuE8IzA?path=" +
        encodedPath +
        "&callback=FomoInlineSetup_73002.fomoInlinePagestreamDataReady&timerange_key=24_hours"
      );
    },

    setup: function () {
      var pathObject = window.location;

      if (document.querySelector) {
        // only do heavylifting when needed
        var canonicalObj = document.querySelector("link[rel='canonical']");
        if (canonicalObj) {
          pathObject = document.createElement("a"); // https://stackoverflow.com/a/15979390/322791
          pathObject.href = canonicalObj.getAttribute("href");
        }
      }

      var path = pathObject.pathname.replace(/\/$/, "");

      var search = pathObject.search;
      if (search) {
        var index = search.indexOf("utm_source");
        if (index > 0) {
          search = search.substring(0, index - 1);
        }
      }
      path += search;

      if (pathObject.hash) {
        path += pathObject.hash;
      }

      var encodedPath = encodeURIComponent(path);

      var script = document.createElement("script");
      script.src = FomoInlineSetup_73002.service_url(encodedPath);
      script.async = true;
      document.head.appendChild(script);
    },
  };

  FomoInlineSetup_73002.setup();
} // snippet should not be run twice if it is requested twice
